import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { EnvironmentService } from 'app/environment.service'
import { AuthHttpService } from 'app/shared/auth-http.service'
import { Observable } from 'rxjs'
import { toParamsObj } from 'app/shared/utils';

@Injectable()
export class AddressService {

    constructor(
        private http: HttpClient,
        private authHttp: AuthHttpService,
        private environmentService: EnvironmentService,
    ) { }

    findAddress(postalCode: string): Observable<IAddressSearchResult[]> {
        let params = {
            'country': 'GBR',
            'postalCode': postalCode
        }

        const url = `${this.environmentService.getOrchestrationUrl()}/address/find`
        return this.authHttp.get<IAddressSearchResult[]>(url, { params: toParamsObj(params) })
    }

    confirmAddress(moniker: string): Observable<IConfirmAddressResult> {
        let params = { 'moniker': moniker }
        const url = `${this.environmentService.getOrchestrationUrl()}/address/confirm`
        return this.authHttp.get<IConfirmAddressResult>(url, { params: toParamsObj(params) })
    }
}

export interface IAddressSearchResult {
    partialAddress: string
    moniker: string
}

export interface IConfirmAddressResult {
    line1: string
    line2: string
    town: string
    postalCode: string
}
